export const Pending = 0;
export const InProgress = 1;
export const Done = 2;
export const Error = 3;
export const Cancelled = 4;
export const InQueue = 5;
export const Interrupted = 6;